import { useQuery } from '@apollo/client';
import React from 'react';
import { FetchTaskListQuery, TaskStatus, TaskType } from '@css-xp/apd-common';
import { ErrorComponents } from '@css-xp/base';
import { useApplicationContext } from '@css-xp/base/common-context';
import { REQUEST_TYPE } from '../../constants/filters';
import { CLOSED_TASKS_TABLE_ROWS } from '../../constants/table';
import { CLOSED_TASK_STATUS } from '../../constants/task';
import { fetchTaskList } from '../../queries/tasks';
import { TaskListTable } from '../task-list-table/task-list-table';
import { createTableHead, createTableRows } from './closed-tasks-list-utils';

interface CloseTaskListProps {
  taskType?: TaskType;
  businessKey?: string | undefined;
}

const ClosedTasksList = ({ taskType = TaskType.MyTasks, businessKey }: CloseTaskListProps) => {
  const user = useApplicationContext();
  const { data, loading, error } = useQuery<FetchTaskListQuery>(fetchTaskList, {
    skip: !user?.userId,
    variables: {
      staffId: user?.userId?.split('@')?.[0],
      taskType: taskType,
      taskStatus: TaskStatus.Completed,
      businessKey,
    },
  });

  const head = React.useMemo(() => createTableHead(true), []);

  const visibleRows = React.useMemo(() => {
    const tasks = data?.taskList?.tasks ?? [];
    return createTableRows({ taskslist: tasks });
  }, [data]);

  if (error) return <ErrorComponents.GenericErrorPage error={error} />;

  return (
    <TaskListTable
      rows={visibleRows}
      head={head}
      rowsPerPage={CLOSED_TASKS_TABLE_ROWS}
      headingText="History"
      isLoading={loading}
      requestTypeFilterOptions={REQUEST_TYPE}
      statusFilterOptions={CLOSED_TASK_STATUS}
    />
  );
};

export default ClosedTasksList;
